import { CommonModule, NgOptimizedImage } from '@angular/common';
import { Component, computed, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { RouterLink } from '@angular/router';
import { TranslocoPipe, TranslocoService } from '@ngneat/transloco';
import { DividerModule } from 'primeng/divider';
import {
  buildPmsUrl,
  PMS_SIGN_IN_PATH,
} from '../../shared/utils/pms-link.util';

interface FooterLink {
  title: string;
  link?: string;
  externalUrl?: string;
}

@Component({
  selector: 'app-footer',
  imports: [
    CommonModule,
    DividerModule,
    NgOptimizedImage,
    RouterLink,
    TranslocoPipe,
  ],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.css',
})
export class FooterComponent {
  protected readonly translocoService = inject(TranslocoService);

  readonly currentYear: string = new Date().getFullYear().toString();

  // Signal che "reagisce" al cambio lingua
  private languageSignal = toSignal(this.translocoService.langChanges$);

  discoverItems = computed(() => {
    // Ricalcola tutto questo array se la lingua cambia.
    this.languageSignal();

    return [
      {
        title: 'footer.discover.links.campsites.title',
        link: '/search',
      },
    ];
  });

  supportItems = computed(() => {
    // Ricalcola tutto questo array se la lingua cambia.
    this.languageSignal();

    return [
      {
        title: 'footer.support.links.help.title',
        link: '/help',
      },
      {
        title: 'footer.support.links.terms.title',
        link: '/terms-and-conditions',
      },
      {
        title: 'footer.support.links.privacy.title',
        link: '/privacy',
      },
    ];
  });

  managerItems = computed<FooterLink[]>(() => {
    // Ricalcola tutto questo array se la lingua cambia.
    this.languageSignal();

    return [
      {
        title: 'footer.managers.links.dashboard.title',
        externalUrl: buildPmsUrl(PMS_SIGN_IN_PATH, 'footer_link', 'footer'),
      },
      {
        title: 'footer.managers.links.join.title',
        link: '/join-us',
      },
    ];
  });
}
